// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import * as React from "react";
import { cn } from "../../lib/utils";

const Badge = ({ className, variant = "default", ...props }) => {
  const variants = {
    default: "text-white shadow-sm",
    success: "text-white shadow-sm",
    warning: "bg-yellow-500 text-white shadow-sm",
    error: "bg-red-600 text-white shadow-sm"
  };

  // ✅ Style dynamique
  const defaultStyle = variant === "default" ? {
    background: 'var(--blue)'
  } : {};

  const successStyle = variant === "success" ? {
    background: 'var(--gold)'
  } : {};

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold",
        variants[variant],
        className
      )}
      style={{ ...defaultStyle, ...successStyle }}
      {...props}
    />
  );
};

export { Badge };